import {
  colorBackgroundContainerContent,
  colorBorderDividerDefault,
  colorTextBodySecondary,
  colorChartsLineAxis,
  colorChartsLineGrid,
  colorChartsLineTick,
  colorChartsPaletteCategorical1,
  colorChartsPaletteCategorical2,
  colorChartsPaletteCategorical3,
  colorChartsPaletteCategorical4,
  colorChartsPaletteCategorical5,
  colorChartsPaletteCategorical6,
  colorChartsPaletteCategorical7,
  colorChartsPaletteCategorical8,
} from '@cloudscape-design/design-tokens'
import { useAppStore } from '@/store/app-store'

/** Cloudscape categorical palette for chart series - sufficient contrast in both modes. */
export const SERIES_PALETTE = [
  colorChartsPaletteCategorical1,
  colorChartsPaletteCategorical2,
  colorChartsPaletteCategorical3,
  colorChartsPaletteCategorical4,
  colorChartsPaletteCategorical5,
  colorChartsPaletteCategorical6,
  colorChartsPaletteCategorical7,
  colorChartsPaletteCategorical8,
]

export function useDesignTokens() {
  // Subscribe to visualMode so Recharts re-renders when the theme changes.
  // The tokens themselves are CSS custom-property values resolved at read time,
  // but Recharts needs a React re-render to pick up the new values.
  useAppStore(s => s.visualMode)

  return {
    chartBg: colorBackgroundContainerContent,
    gridColor: colorBorderDividerDefault,
    axisLabelColor: colorTextBodySecondary,
    tooltipBg: colorBackgroundContainerContent,
    axisStroke: colorChartsLineAxis,
    lineGrid: colorChartsLineGrid,
    tickColor: colorChartsLineTick,
    seriesPalette: SERIES_PALETTE,
  }
}
